<template>
  <div class="orderContent">
    <navBar :title="topTitle"></navBar>
    <div class="box">
      <div class="orderitem flexBetween" v-for="(item,index) in orderInfo.item_lists" :key="index">
        <div class="name">{{item.service_content}}</div>
        <div :class="item.price=='0'||item.price==''?'bPrice':'rPrice'" @click="getgoodsId(item.id)" v-if="statusId!=10">
          {{item.price=='0'||item.price==''?'待填写价格':item.price}}
        </div>
      </div>
    </div>
    <div class="box flexBetween">
      <div class="left">
        <div class="address">{{orderInfo.service_address?orderInfo.market_name +
          orderInfo.service_address.building_room:''}}
        </div>
        <div class="info">{{orderInfo.service_address?orderInfo.account_name + ' ' +
          orderInfo.service_address.mobile:''}}
        </div>
      </div>
      <div class="phone" @click="contactUser"></div>
    </div>
    <div class="orderInfo box">
      <div class="title">订单信息</div>
      <div class="infoCont">
        <div class="orderSn flexBetween">
          <div class="name">订单号</div>
          <div class="value">{{orderInfo.service_sn}}
            <span v-clipboard:copy="orderInfo.service_sn" v-clipboard:success="copySuc"
                  v-clipboard:error="copyFail">复制</span></div>
        </div>
        <div class="orderTime flexBetween">
          <div class="name">下单时间</div>
          <div class="value">{{orderInfo.create_time}}</div>
        </div>
      </div>

    </div>
    <!--代配送订单流程-->
    <div class="box" v-if="statusId!=10">
      <van-steps direction="vertical" active="10" active-color="#8D95A6">
        <van-step v-for="(sItem,sIndex) in orderInfo.service_log" :key="sIndex">
          <div class="flexBetween">
            <b class="title">{{sItem.content}}</b>
            <p class="time">{{sItem.opeate_time}}</p>
          </div>
        </van-step>
      </van-steps>
    </div>

    <van-button type="primary" block @click="sureOrder"
                :loading="loading"
                loading-type="circular"
                :loading-text="buttonText"
                :disabled="loading"
                v-if="statusId==10||statusId==20||statusId==30">{{buttonText}}
    </van-button>

    <!--输入价格-->
    <van-popup v-model="popShow" style="width: 80%;height: 30%;" v-if="statusId==20">
      <div class="input" style=";border: 1px solid #8D95A6;width: 80%;margin: 40px auto">
        <van-field v-model="price" :autofocus="popShow" type="number" placeholder="请输入价格"/>
      </div>
      <div class="btnBox">
        <van-button round size="normal" color="#687BFF" type="info" @click="surePrice">确定</van-button>
      </div>
    </van-popup>

    <!--包含未填写价格弹框确认-->
    <div class="black" v-show="nullPrice" v-if="statusId==20">
      <div class="dialog">
        <div class="title">有物品未填写价格</div>
        <div class="btnGroup flexBetween">
          <van-button plain color="#4683F5" @click="buyFinish">强制完成</van-button>
          <van-button color="#4683F5" @click="dialogCancel">返回补充</van-button>
        </div>
        <div class="close" @click="dialogCancel"></div>
      </div>
    </div>

  </div>
</template>

<script>
  import navBar from "../../components/navBar";
  import Vue from 'vue';
  import {Toast, Button, Loading, Popup, Field, Step, Steps,Dialog } from 'vant';

  Vue.use(Toast).use(Button).use(Loading).use(Popup).use(Field).use(Step).use(Steps).use(Dialog);
  export default {
    name: "orderContent",
    components: {
      navBar
    },
    data() {
      return {
        topTitle: '',
        loading: false,//按钮加载
        orderInfo: {},
        orderId: this.$route.query.id,
        popShow: false,//弹出框显示
        price: '',
        goodsId: '',
        orderPrice: [],
        statusId: this.$route.query.status,
        buttonText: '',
        nullPrice: false, //包含未填写的价格
        lists: {}//价格
      }
    },
    mounted() {
      this.getTopTitle();
      this.getOrderInfo();
    },
    methods: {
      //拨打电话
      contactUser(){
        Dialog.confirm({
          message: this.orderInfo.service_address.mobile,
          confirmButtonText:'呼叫'
        }).then(() => {
          window.location.href = `tel:${this.orderInfo.service_address.mobile}`;
        }).catch(() => {
          // on cancel
        });

      },
      //获取相关订单id
      getgoodsId(id) {
        if (this.statusId == '20') {
          this.popShow = true;
          this.goodsId = id;
        }
      },
      //价格确认
      surePrice() {
        this.popShow = false;
        let itemList = this.orderInfo.item_lists;
        for (let i = 0; i < itemList.length; i++) {
          let id = itemList[i].id;
          if (this.goodsId == id) {
            itemList[i].price = this.price;
          }
        }
        this.price = '';
      },
      //订单提交
      sureOrder() {
        let statusId = this.statusId;
        this.loading = true;

        //待确认提交
        if (this.orderId && statusId == '10') {
          this.sendHttp({
            method: 'post',
            url: `${this.orderUrl}/marketservice/confirm`,
            data: {
              market_service_id: this.orderId
            }
          }).then(res => {
            this.loading = false;
            if (res.code == '0') {
              this.$router.push('/dgOrder');
            }
            Toast(res.msg);
          })
        }
        //待购买提交
        if (this.orderId && statusId == '20') {
          //初始化orderPrice
          let orderList = this.orderInfo.item_lists;
          let obj = {};
          if (orderList) {
            for (let i = 0; i < orderList.length; i++) {
              let id = orderList[i].id;
              let price = orderList[i].price;
              if (price == '0' || price == '') {
                this.nullPrice = true;
              }
              this.$set(obj, id, price)
            }
            this.lists = obj;
            console.log(this.lists)
            if (this.nullPrice === false) {
              this.buyFinish();
            }
          }
        }

        //配送完成
        if (this.orderId && statusId == '30') {
          this.loading = true;
          this.sendHttp({
            method: 'post',
            url: `${this.orderUrl}/marketservice/finish`,
            data: {
              market_service_id: this.orderId
            }
          }).then(res => {
            this.loading = false;
            if (res.code == '0') {
              this.$router.push('/dgOrder');
            }
            Toast(res.msg);
          })
        }
      },
      //购买完成
      buyFinish() {
        this.nullPrice = false;
        this.sendHttp({
          method: 'post',
          url: `${this.orderUrl}/marketservice/buy`,
          data: {
            market_service_id: this.orderId,
            lists: JSON.stringify(this.lists)
          }
        }).then(res => {
          // console.log(res)
          this.loading = false;
          if (res.code == '0') {
            this.$router.push('/dgOrder');
          }
          Toast(res.msg);
        })
      },
      //返回补充价格
      dialogCancel() {
        this.nullPrice = false;
      },
      //获取头部标题
      getTopTitle() {
        let statusId = this.$route.query.status;
        if (statusId == 0) {
          this.topTitle = '代购-已取消';
        }
        if (statusId == 10) {
          this.topTitle = '代购-待确认';
          this.buttonText = '确认';
        }
        if (statusId == 20) {
          this.topTitle = '代购-待购买';
          this.buttonText = '购买完成';
        }
        if (statusId == 30) {
          this.topTitle = '代购-待配送';
          this.buttonText = '配送完成';
        }
        if (statusId == 50) {
          this.topTitle = '代购-已完成';
        }
      },
      //获取当前订单详情
      getOrderInfo() {
        if (this.orderId) {
          this.sendHttp({
            method: 'post',
            url: `${this.orderUrl}/marketservice/detail`,
            data: {
              market_service_id: this.orderId
            }
          }).then(res => {
            console.log(res)
            this.orderInfo = res.data;
          })
        }
      },
      copySuc() {
        Toast('复制成功');
      },
      copyFail() {
        Toast('复制失败');
      }
    }
  }
</script>

<style scoped lang="less">
  .black {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;

    .dialog {
      background: #fff;
      width: 327px;
      height: 200px;
      border-radius: 4px;
      text-align: center;
      position: relative;

      .title {
        padding: 48px 0;
        font-size: 16px;
      }

      .btnGroup {
        padding: 0 26px;
      }

      .van-button {
        width: 127.4px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
      }

      .close {
        width: 26px;
        height: 33px;
        background: url("../../assets/images/close.png") no-repeat;
        background-size: contain;
        position: absolute;
        top: 0;
        right: 16px;
      }
    }
  }

  .btnBox {
    display: flex;
    justify-content: center;

    .van-button--normal {
      padding: 0 25px;
    }
  }

  .van-button--primary {
    background-color: #687BFF;
    border: none;
    font-size: 16px;
    width: 347px;
    margin: 0 auto;
    margin-top: 80px;
    height: 48px;
    line-height: 48px;
  }

  .orderContent {
    background: #f5f5f5;
    position: absolute;
    width: 100%;
    min-height: 100%;

    .box {
      background: #fff;
      margin-top: 6px;
      padding: 0 14px;

      .left {
        padding: 12px 0;

        .info {
          color: #8D95A6;
          font-size: 13px;
          line-height: 30px;
        }
      }

      .phone {
        width: 17px;
        height: 17px;
        background: url("../../assets/images/phone.png") no-repeat;
        background-size: contain;
      }
    }

    .orderInfo {
      .title {
        line-height: 44px;
        border-bottom: 1px solid #F5f5f5;
        font-weight: bold;
      }

      .infoCont {
        line-height: 26px;
        padding: 10px 0;

        .name {
          color: #8D95A6;
        }

        .value {
          span {
            padding-left: 10px;
            color: #687BFF;
            text-decoration: underline;
          }
        }
      }

    }

    .orderitem {
      line-height: 40px;
      font-size: 14px;

      .bPrice {
        color: #687BFF;
      }

      .rPrice {
        color: #DE1919;
      }
    }
  }

</style>
<style>
  .van-step--finish .van-step__circle, .van-step--finish .van-step__line {
    background: #8D95A6 !important;
  }
</style>
